import { Core, BILL_OF_LADING } from '../Core';

interface UploadBillOfLadingData {
  movementId: number;
  data: {
    billOfLadingFileBase64: ArrayBuffer | string | null;
    fileName?: string;
  };
}

class BillOfLading extends Core {
  uploadBillOfLading = async ({ movementId, data }: UploadBillOfLadingData) =>
    this.post(BILL_OF_LADING(movementId), data);

  deleteBillOfLading = async (movementId: number) =>
    this.delete(BILL_OF_LADING(movementId));
}

export const billOfLading = new BillOfLading();
